import request from '@/utils/request'
import router from '@/router'
import { downloadBlob } from '../../utils/helpers'
import uuid from 'uniq-id'

export default {
    getRoles: async({ commit, dispatch }, params) => {
        commit('SET_LOAD', true)
        await request({
            method: 'get',
            url: '/role',
            responseType: params.excel ? 'blob' : 'json',
            params
        }).then(res => {
            if (res.data && res.data.items) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total,
                    limit: res.data.limit
                })

                commit('SET_ROLES', res.data.items)
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.message
            }, { root: true })
        }).finally(() => {
            commit('SET_LOAD', false)
        })
    },

    getRoleById: async({ commit, dispatch }, id) => {
        return request({
            method: 'get',
            url: `role/${id}`
        }).then(res => {
            return res
        }).catch(error => {
            if (error.response && error.response.data.code === 404) {
                router.push('/roles/editor')
            }

            dispatch('addMessage', {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }, { root: true })

            return error
        })
    },

    createRole: async({ commit, dispatch }, data) => {
        commit('SET_LOAD', true)
        return request({
            method: 'post',
            url: '/role',
            data
        }).then(res => {
            if (res.data) {
                dispatch('addMessage', {
                    message: 'role.created',
                    type: 'success',
                    locale: true
                }, { root: true })
            }

            return res
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.data.message
            }, { root: true })
        }).finally(() => {
            commit('SET_LOAD', false)
        })
    },

    updateRole: async({ commit, dispatch }, data) => {
        commit('SET_LOAD', true)
        return request({
            method: 'put',
            url: `role/${data.id}`,
            data
        }).then(res => {
            if (res.data) {
                commit('UPDATE_ROLE', res.data)

                dispatch('addMessage', {
                    message: 'role.updated',
                    type: 'success',
                    locale: true
                }, { root: true })
            }

            return res
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message,
                locale: true
            }, { root: true })

            return error
        }).finally(() => {
            commit('SET_LOAD', false)
        })
    },

    removeRole: async({ commit, dispatch }, id) => {
        await request({
            method: 'delete',
            url: `role/${id}`
        }).then(res => {
            if (res.status === 204) {
                dispatch('addMessage', {
                    message: 'role.removed',
                    type: 'success',
                    locale: true
                }, { root: true })
            }
        }).catch(error => {
            dispatch('addMessage', {
                type: 'error',
                message: error.response.data.message,
                locale: true
            }, { root: true })
        })
    },

    getRolesList: async({ commit }) => {
        await request({
            method: 'get',
            url: '/role/all'
        }).then(res => {
            if (res.data) {
                commit('SET_ROLES_LIST', res.data)
            }
        })
    },

    getPermissions: async({ commit }) => {
        await request({
            method: 'get',
            url: '/permission'
        }).then(res => {
            if (res.data) {
                commit('SET_PERMISSIONS', res.data)
            }
        })
    },

    updatePermissions: ({ commit }, data) => {
        return request({
            method: 'put',
            url: '/permission',
            data
        })
    }
}
